export default __webpack_public_path__ + "static/signpainter-housescript-d31ce8502e91a1093b01f2de7e5772e4.woff";